import React, { useState, useEffect } from 'react';
import { Button, Divider, Modal, Table as TableSemantic, Icon, Header, Grid } from 'semantic-ui-react';
import request from 'services/http';
import { toast } from 'react-toastify';
import Table from 'components/Table';
import PageLoader from 'components/PageLoader';
import { numFormat } from '@rededompedro/utils';
import { DateTime } from 'luxon';
import { download } from '@rededompedro/utils';
import './style.css';

export default function Reports({ history, empresas, dadosReports, setDadosReports }) {
    const params = Object.fromEntries(
        new URLSearchParams(history.location.search.replace('?=', '')).entries(),
    );
    const emp = empresas.find((it) => it && it.codDpnet === params.empresa);

    const [open, setOpen] = React.useState(false)
    const [dataObservacao, setDataObservacao] = useState([])
    const [selectedRow, setSelectedRow] = useState()



    useEffect(() => {
        setDadosReports({
            reports: null,
        });
        request({
            url: '/controladoria/relatorios',
            method: 'GET',
            params,
        })
            .toPromise()
            .then(({ response }) => {
                console.log("RESPONSE", response)
                setDadosReports({
                    reports: response.reportFinal,
                });
            })
            .catch((err) => {
                toast.error('Falha ao carregar dados!');
            })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const openObservacoes = async (it) => {

        await request({
            url: '/controladoria/relatorios/dpnet',
            method: 'GET',
            params: {
                empresa: it.cod_emp,
                id_data: it.id_data
            },
        })
            .toPromise()
            .then(({ response }) => {
                if (response) {
                    setSelectedRow(it)
                    setDataObservacao(response)

                } else {
                    return toast.error('Houve um problema interno.', {
                        toastId: 'vereficar-desconto-error',
                    });
                }
            })
            .catch((err) => {
                return toast.error('Houve um problema interno.', {
                    toastId: 'vereficar-desconto-error',
                });
            });


        setOpen(true)


    }

    const downloadFile = (selectedRow) => {
        const payload = {
            download: selectedRow.anexo,
        };
        request({
            url: `/controladoria/download`,
            method: 'GET',
            responseType: 'blob',
            params: payload,
        })
            .toPromise()
            .then((data) => {
                download(data.response, `${selectedRow.nome_funcionario}-${selectedRow.descricao}.pdf`);
                toast.success('Download realizado com sucesso!', {
                    toastId: selectedRow.seq + 'download-success',
                });
            })
            .catch((err) => {
                toast.error('Falha ao realizar Download do arquivo!', {
                    toastId: selectedRow.seq + 'download-error',
                });
            });
    };



    const table = {
        columns:
            params.tipo === '2'
                ? [
                    { field: 'seq', text: 'Sequência', sort: true },
                    { field: 'data', text: 'Data do Caixa', sort: true },
                    { field: 'turno', text: 'Turno', sort: true },
                    { field: 'diferenca', text: 'Diferença', sort: true },
                    { field: 'descricao', text: 'Justificativa', sort: true },
                    { field: 'valor', text: 'Valor', sort: true },
                    { field: 'colaborador', text: 'Colaborador(a)', sort: true },
                    { field: 'controlador', text: 'Controlador(a)', sort: true },
                    { field: 'registrado', text: 'Data Registro', sort: true },
                    { field: 'deletado', text: 'Data Exclusão', sort: true },
                ]
                : [
                    { field: 'seq', text: 'Sequência', sort: true },
                    { field: 'data', text: 'Data do Caixa', sort: true },
                    { field: 'turno', text: 'Turno', sort: true },
                    { field: 'diferenca', text: 'Diferença', sort: true },
                    { field: 'descricao', text: 'Justificativa', sort: true },
                    { field: 'valor', text: 'Valor', sort: true },
                    { field: 'parcela', text: 'Nº Parcela(s)', sort: false },
                    { field: 'colaborador', text: 'Colaborador(a)', sort: true },
                    { field: 'controlador', text: 'Controlador(a)', sort: true },
                    { field: 'registrado', text: 'Data Registro', sort: true },
                    { field: 'sistema', text: 'Sistema', sort: true },
                    { field: 'visualizar', text: 'Observações', sort: true },
                ],
        data: dadosReports.reports
            ? dadosReports.reports.map((item) => ({
                parcela: item.parcela ? item.parcela : 'Vazio',
                turno: item.turno,
                diferenca: 'R$ ' + numFormat(item.diferenca),
                descricao: item.descricao,
                seq: item.seq,
                valor: item.valor ? 'R$ ' + numFormat(item.valor) : 'Vazio',
                colaborador: item.nome_funcionario
                    ? item.nome_funcionario.toLowerCase().replace(/(?:^|\s)\S/g, (a) => {
                        return a.toUpperCase();
                    })
                    : 'Sem colaborador(a) vinculado', // formata o nome funcionário
                controlador: item.nome_central ? item.nome_central : 'Vazio',
                data: item.data,
                sistema: item.sistema,
                registrado: item.created_at ? DateTime.fromFormat(
                    String(item.created_at),
                    'yyyy-MM-dd HH:mm:ss',
                ).toFormat('dd/MM/yyyy HH:mm:ss') : 'Vazio',
                //responsavel: item.deleted_status === 1 ? 'Controladoria':'Master-DPnet',
                deletado: DateTime.fromFormat(
                    String(item.deleted_at),
                    'yyyy-MM-dd HH:mm:ss',
                ).toFormat('dd/MM/yyyy HH:mm:ss'),
                visualizar: (
                    <Button
                        onClick={() => openObservacoes(item)}
                        icon
                        size="mini"
                        color="instagram"
                        labelPosition="right"
                        content={
                            <>
                                <Icon name="arrow right" /> Visualizar
                            </>
                        }
                    />
                ),
            }))
            : [],
        filter: true,
        exportData: true,
    };




    return (
        <>
            <PageLoader active={dadosReports.reports === null}>
                <div className="row mt-2 ">
                    <div className="col-9  d-flex align-items-end">
                        <div>
                            <p className="mb-0">
                                <strong>
                                    {`Relatório de ${params.tipo === '1' ? 'Justificativas' : 'Estornos'
                                        }`}
                                    &ensp;-
                                </strong>
                            </p>
                        </div>

                        <div className="ml-2">
                            <p className="mb-0">
                                <strong>Empresa: </strong> {emp ? emp.nomeEmpresa : ''} -{' '}
                                {params.dataIni + ' Até ' + params.dataFim}
                            </p>
                        </div>
                    </div>

                    <div className="col-3 col- d-print-none">
                        <Button
                            icon
                            size="tiny"
                            className="btn-red"
                            floated="right"
                            onClick={() => history.goBack()}
                        >
                            <Icon name="arrow left" /> Voltar
                        </Button>
                        <Button
                            icon
                            size="tiny"
                            className="btn-primary"
                            floated="right"
                            onClick={() => window.print()}
                        >
                            <Icon name="print" /> Imprimir
                        </Button>
                    </div>
                </div>

                <Divider className="mt-2 custom-divider darken" fitted />
                {dadosReports && (
                    <Table
                        id="table-justificativas"
                        collapsing
                        //celled
                        size="small"
                        sortable
                        {...table}
                    />
                )}
            </PageLoader>


            <Modal
                size='fullscreen'
                onClose={() => setOpen(false)}
                onOpen={() => setOpen(true)}
                open={open}
            >
                <Modal.Header>
                    <Grid>
                        <Grid.Column floated="left" width={11}>
                            <Header as="h3" floated="left">
                                Diferença R$ {selectedRow?.diferenca}
                                <Header.Subheader
                                    style={{
                                        backgroundColor: '#1a4b84',
                                        color: 'white',
                                    }}
                                >
                                    {emp ? emp.nomeEmpresa : ''}
                                </Header.Subheader>
                            </Header>
                        </Grid.Column>
                        <Grid.Column floated="right" width={5}>
                            <Header as="h4" floated="right">
                                Data do caixa -  {selectedRow?.data}
                                <Header.Subheader
                                    style={{
                                        backgroundColor: '#1a4b84',
                                        color: 'white',
                                    }}
                                >
                                    Turno {selectedRow?.turno}
                                </Header.Subheader>
                            </Header>
                        </Grid.Column>
                    </Grid>

                </Modal.Header>
                <Modal.Content>
                    <h4 style={{ textAlign: 'center' }}>Histórico Dpnet</h4>
                    <TableSemantic compact >
                        <TableSemantic.Header>
                            <TableSemantic.Row>
                                <TableSemantic.HeaderCell width={2} style={{ width: '15%' }} >Data</TableSemantic.HeaderCell>
                                <TableSemantic.HeaderCell width={2} style={{ width: '15%' }}> Usuário</TableSemantic.HeaderCell>
                                <TableSemantic.HeaderCell >Observação</TableSemantic.HeaderCell>
                            </TableSemantic.Row>
                        </TableSemantic.Header>

                        <TableSemantic.Body>
                            <>
                                {dataObservacao && dataObservacao.map((item, index) => (
                                    <TableSemantic.Row key={index}>
                                        <TableSemantic.Cell>{`${item.data_evt} ${item.hora}`}</TableSemantic.Cell>
                                        <TableSemantic.Cell>{item.nome}</TableSemantic.Cell>
                                        <TableSemantic.Cell>{item.obs}</TableSemantic.Cell>
                                    </TableSemantic.Row>
                                ))}

                            </>
                        </TableSemantic.Body>
                    </TableSemantic>


                    <>
                        <h4 style={{ textAlign: 'center' }}>Observações referente a {selectedRow?.descricao}</h4>
                        <TableSemantic compact >
                            <TableSemantic.Header>
                                <TableSemantic.Row>
                                    <TableSemantic.HeaderCell width={2} style={{ width: '15%' }} >Data</TableSemantic.HeaderCell>
                                    <TableSemantic.HeaderCell width={2} style={{ width: '15%' }}> Usuário</TableSemantic.HeaderCell>
                                    <TableSemantic.HeaderCell >Observação</TableSemantic.HeaderCell>
                                </TableSemantic.Row>
                            </TableSemantic.Header>

                            <TableSemantic.Body>
                                <TableSemantic.Row>
                                    <TableSemantic.Cell>{selectedRow?.created_at ? DateTime.fromFormat(
                                        String(selectedRow.created_at),
                                        'yyyy-MM-dd HH:mm:ss',
                                    ).toFormat('dd/MM/yyyy HH:mm:ss') : '-'}</TableSemantic.Cell>
                                    <TableSemantic.Cell> {selectedRow?.nome_central ? selectedRow.nome_central : '-'}</TableSemantic.Cell>
                                    <TableSemantic.Cell>{selectedRow?.observacao ? selectedRow.observacao : '-'}</TableSemantic.Cell>
                                </TableSemantic.Row>
                            </TableSemantic.Body>
                        </TableSemantic>
                    </>
                </Modal.Content>

                {
                    selectedRow?.anexo !== undefined ? (
                        <Modal.Actions>
                            <Button color='green' onClick={() => downloadFile(selectedRow)}>
                                <Icon name='download' /> Download Anexo
                            </Button>
                        </Modal.Actions>
                    ) : null
                }

            </Modal>
        </>
    );
}
